import { useTranslation } from 'react-i18next';
import type { PimCertificationConfig } from 'src/lib/pim-certifications';

export function PimCertificationsList({ certifications }: { certifications: PimCertificationConfig[] }) {
    const { t } = useTranslation('product');

    if (certifications.length === 0) {
        return null;
    }

    return (
        <ul className="m-0 flex list-none flex-wrap gap-3 p-0">
            {certifications.map(({ code, labelKey, iconSrc }) => (
                <li key={code} className="flex items-center gap-1 bg-neutral-white rounded-sm px-2 py-1">
                    <img src={iconSrc} alt={t(labelKey as never)} className="size-6 shrink-0 object-contain" />
                </li>
            ))}
        </ul>
    );
}
